import { Component, Input } from '@angular/core';
import { FetchResponse } from 'src/app/shared/models/api-response.interface';
import { FeaturedBrand } from '../../models/featuredbrand-interface';
import { environment } from './../../../../../environments/environment';

@Component({
  selector: 'app-home-featuredbrands',
  templateUrl: './home-featuredbrands.component.html',
  styleUrls: ['./home-featuredbrands.component.scss'],
  standalone:false
})
export class HomeFeaturedbrandsComponent {
  host_url: string = environment.imageURL;
  @Input() featuredBrand!: FetchResponse<FeaturedBrand[]>;
  getImage(url : string) : string{
    return this.host_url + url;
  }
}
